import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import requests from 'app/requests/Quote/SimplifiedQuote.requests'
import SimplifiedCQuoteOverview from './SimplifiedCQuoteOverview'
import SimplifiedCQuoteUpdate from './SimplifiedCQuoteUpdate'
import tableConfig from './SimplifiedCQuotes.config'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

export default function SimplifiedCQuotes() {
    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: CommonRoutes.Overview,
                Component: SimplifiedCQuoteOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Data Update',
                url: CommonRoutes.DataUpdate,
                Component: SimplifiedCQuoteUpdate,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            name={tableConfig.name}
            sidebarTabs={tabs}
            defaultTab={CommonRoutes.Overview}
        >
            <SkyNetTable
                customUrl={requests.filterRequest().url}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>
    )
}
